import {
    Business,
    CalendarMonth,
    Dashboard,
    ExpandLess,
    ExpandMore,
    People,
    PointOfSale,
} from "@mui/icons-material";
import {
    Collapse,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import { Fragment, useContext, useEffect, useMemo, useState } from "react";
import Loadable from "react-loadable";
import { useHistory, useParams } from "react-router-dom";
import Loading from "../Loading";
import SimpleDashboard from "../SimpleDashboard/SimpleDashboard";
import UserContext, { User_Type } from "../UserContext";
// import Users from "../account-book/Users";
import Absenties_Page from "../absenties/absenties-page";
import Admin_Page from "../admin/admin-page";
import Api_Keys_Page from "../api-keys/api-keys-page";
import Archive from "../Archive/Archive";
import Attendance_Page from "../attendance/attendance-page";
import Branches_Page from "../branches/branches-page";
import Devices_Page from "../devices/devices-page";
import Organizations_Page from "../organization/organizations-page";
import DataImport from "../users/DataImport";
import TodaySyncUsers from "../users/TodaySyncUsers";
import Users_Page from "../users/users-page";
import SimpleSidebarComponent from "./SimpleSidebarComponent";

const AsyncMultiPermissionAuthorize = Loadable({
    loader: () => import("../MultiPermissionAuthorize"),
    loading: Loading,
});

export const superadmin_modules = {
    Dashboard: [
        {
            name: "Dashboard",
            component: <SimpleDashboard />,
            permissions: [],
            href: "/superadmin/",
            icon: <Dashboard />,
        },
    ],

    Organizations: [
        {
            name: "Oragnizations",
            component: <Organizations_Page />,
            permissions: [],
            href: "/superadmin/organizations",
            icon: <Business />,
        },

        {
            name: "Oragnization Admin",
            component: <Admin_Page />,
            permissions: [],
            href: "/superadmin/admin-page",
            icon: <Business />,
        },

        {
            name: "Api Keys",
            component: <Api_Keys_Page />,
            permissions: [],
            href: "/superadmin/api-keys",
            icon: <PointOfSale />,
        },

        {
            name: "Branches",
            component: <Branches_Page />,
            permissions: [],
            href: "/superadmin/organizations/branches",
        },
    ],

    Devices: [
        {
            name: "Devices",
            component: <Devices_Page />,
            permissions: [],
            href: "/superadmin/devices",
            icon: <PointOfSale />,
        },
    ],
};

export const orgadmin_modules = {
    Dashboard: [
        {
            name: "Dashboard",
            component: <SimpleDashboard />,
            permissions: ["READ SIMPLE_DASHBOARD"],
            href: "/admin/",
            icon: <Dashboard />,
        },
    ],

    Branches: [
        {
            name: "Branches",
            component: <Branches_Page />,
            permissions: [],
            href: "/admin/branches",
            icon: <Business />,
        },
    ],

    Devices: [
        {
            name: "Devices",
            component: <Devices_Page />,
            permissions: ["READ USERS"],
            href: "/admin/devices",
            icon: <PointOfSale />,
        },
    ],

    Users: [
        {
            name: "Users",
            component: <Users_Page />,
            permissions: ["READ USERS"],
            href: "/admin/users",
            icon: <People />,
        },

        {
            name: "Import",
            component: <DataImport />,
            permissions: ["CREATE USER"],
            href: "/admin/users/import",
            icon: <People />,
        },

        {
            name: "Single User Sync",
            component: <TodaySyncUsers />,
            permissions: ["CREATE USER"],
            href: "/admin/users/single-user-sync",
            icon: <People />,
        },
    ],

    Attendance: [
        {
            name: "Attendance",
            component: <Attendance_Page />,
            permissions: ["READ USERS"],
            href: "/admin/attendance",
            icon: <CalendarMonth />,
        },
        {
            name: "Absenties",
            component: <Absenties_Page />,
            permissions: ["READ USERS"],
            href: "/admin/attendance/absenties",
        },
    ],

    Archive: [
        {
            name: "Archive",
            component: <Archive />,
            permissions: ["READ USERS"],
            href: "/admin/archive",
            icon: <PointOfSale />,
        },
    ],
};

export default function Sidebar({ variant, setComponent }: any) {
    // const classes = useStyles();
    const history = useHistory();
    const { user, permissions } = useContext(UserContext);
    const [selected, setSelected] = useState("");
    const [open, setOpen] = useState({});
    const params = useParams<{ user_type: User_Type }>();

    const modules = useMemo(() => {
        if (!user) return {};

        switch (user.user_type) {
            case "superadmin":
                return superadmin_modules;
            case "admin":
                return orgadmin_modules;
            default:
                return {};
        }
    }, [user?.user_type]);

    const handleSelect = (subModule: any) => {
        setSelected(subModule.name);
        setComponent(subModule.component);
    };

    useEffect(() => {
        Object.keys(modules).map((mod) => setOpen({ ...open, mod: false }));
    }, []);

    return (
        // user && (
        <List>
            {
                // permissions &&
                //     user &&
                Object.entries(modules)
                    // .sort((a, b) => b[1].length - a[1].length)
                    .map(([module, subModules]: any, idx) =>
                        subModules.length === 1 ? (
                            // <AsyncMultiPermissionAuthorize
                            //     ops={subModules[0].permissions || []}
                            //     strategy="some"
                            //     key={`${module}-${idx}`}
                            // >
                            <SimpleSidebarComponent
                                name={module}
                                href={subModules[0].href}
                                key={`${module}-${idx}`}
                                icon={subModules[0].icon}
                            />
                        ) : (
                            // </AsyncMultiPermissionAuthorize>
                            <Fragment key={idx}>
                                {subModules
                                    .map((sub: any) => sub.permissions || [])
                                    // .reduce((ops: any, op: any) => [
                                    //     ...ops,
                                    //     ...op,
                                    // ])
                                    .some(
                                        (op: any) => true
                                        // permissions.includes(op)
                                    ) ? (
                                    <ListItemButton
                                        onClick={() =>
                                            setOpen({
                                                ...open,
                                                [module]:
                                                    !open[
                                                        module as keyof typeof open
                                                    ],
                                            })
                                        }
                                    >
                                        {subModules[0].icon && (
                                            <ListItemIcon>
                                                {subModules[0].icon}
                                            </ListItemIcon>
                                        )}

                                        <ListItemText primary={module} />
                                        {open[module as keyof typeof open] ? (
                                            <ExpandLess />
                                        ) : (
                                            <ExpandMore />
                                        )}
                                    </ListItemButton>
                                ) : null}

                                <Collapse
                                    in={open[module as keyof typeof open]}
                                    timeout="auto"
                                    unmountOnExit
                                >
                                    <List dense disablePadding>
                                        {subModules.map(
                                            (subModule: any, idx2: number) => (
                                                // <AsyncMultiPermissionAuthorize
                                                //     ops={
                                                //         subModule.permissions ||
                                                //         []
                                                //     }
                                                //     key={idx2}
                                                //     strategy="some"
                                                // >
                                                <ListItemButton
                                                    sx={{ pl: 9 }}
                                                    key={idx2}
                                                    selected={
                                                        selected ===
                                                        subModule.name
                                                    }
                                                    // className={
                                                    //     classes.nested
                                                    // }
                                                    onClick={() => {
                                                        handleSelect(subModule);
                                                        history.push(
                                                            subModule.href
                                                        );
                                                    }}
                                                >
                                                    <ListItemText
                                                        primary={subModule.name}
                                                    />
                                                </ListItemButton>
                                                // </AsyncMultiPermissionAuthorize>
                                            )
                                        )}
                                    </List>
                                </Collapse>
                            </Fragment>
                        )
                    )
            }
        </List>
        // )
    );
}
